export enum Language {
  DE = 'de',
  DE_DE = 'de-DE',
  AT = 'at',
  DE_AT = 'de-AT',
  CH = 'ch',
  DE_CH = 'de-CH',
  fr_CH = 'fr-CH'
}

export enum Tenant {
  DE = 'DE',
  AT = 'AT',
  CH = 'CH'
}

export enum Currency {
  EUR = 'EUR'
}

export enum ConfigUrlParams {
  LANGUAGE = 'lng',
  CURRENCY = 'cur'
}

export const getLanguageFromTenant = (tenant?: string | null) => {
  switch (tenant) {
    case Tenant.AT:
      return Language.DE_AT;
    case Tenant.CH:
      return Language.DE_CH;
    default:
      return Language.DE;
  }
};

export const languages = Object.values(Language).sort((a, b) => a.localeCompare(b));
export const currency = Object.values(Currency).sort((a, b) => a.localeCompare(b));
